module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.switches')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": _vm.switches,
      "columns": ['controllerName', 'switchGroupNames', 'name'],
      "operations": _vm.operations,
      "custom-sort": _vm.sort
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6528e110!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/SwitchList.vue
// module id = 1005
// module chunks = 2